export default "__VITE_ASSET__BEPsuuSa__"